export function Approved() {
  // Placeholder
  return null
}
